const contractAddress = "0x71288635F5CCC221B040617aA518199Afc245E33"

export default contractAddress